import { render, staticRenderFns } from "./NewBasket.vue?vue&type=template&id=4d756e45&scoped=true&"
import script from "./NewBasket.vue?vue&type=script&lang=js&"
export * from "./NewBasket.vue?vue&type=script&lang=js&"
import style0 from "./NewBasket.vue?vue&type=style&index=0&id=4d756e45&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d756e45",
  null
  
)

export default component.exports